export default class Archive {
	constructor() {
		this.activeTab = 'all';
		this.origPosts = undefined;
		this.callingAdditionalPosts = false;
		this.postIds = [];
		this.sortBy = undefined;
	}

	init = () => {
		$(document).ready(() => {
			this.sortBy = $('.archive').data('sort');
			this.origPosts = $('.archive__posts .post-item').clone();
			// this.addClickEventToCatItem();
			this.consolidatePostId(this.origPosts);
			// this.addOnScrollPagination();
			this.addMobileFilterToggle();
		});
	};

	addOnScrollPagination = () => {
		$(window).on('scroll', async () => {
			const scrollTop = $(window).scrollTop();
			const winHeight = $(window).height();
			const docHeight = $(document).height();
			const scrolledRatio = (scrollTop + winHeight) / docHeight;

			if (scrolledRatio >= 0.5 && !this.callingAdditionalPosts) {
				this.callingAdditionalPosts = true; // Prevent multiple calls

				try {
					const result = await this.fetchAdditionalPosts();
					if (result?.html) {
						await this.appendResults(result.html);
					}
				} catch (err) {
					console.error('Error fetching additional posts:', err);
				} finally {
					this.callingAdditionalPosts = false; // Reset flag after everything is done
				}
			}
		});
	};

	fetchAdditionalPosts = async () => {
		if (!this.postIds.length) return null;

		const payload = {
			excluded_ids: this.postIds,
			category: this.activeTab,
			sort: this.sortBy,
			limit: 9
		};

		// Add search query if available
		const searchQuery = $('.archive input[name="search_query"]').length > 0 ? $('.archive input[name="search_query"]').val() : '';
		if (searchQuery !== '') {
			payload.search = searchQuery;
		}

		const response = await fetch('/wp-json/ultrax/v1/posts', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payload)
		});

		if (!response.ok) throw new Error('Network response was not ok');
		return response.json();
	};

	appendResults = async (html) => {
		$('.archive__posts').append(html);
		this.origPosts = $(document).find('.archive__posts .post-item').clone();
		this.consolidatePostId(this.origPosts);
	};

	addClickEventToCatItem = () => {
		const catItem = '.archive__categories__item';
		this.activeTab = $(catItem + '.is-active').data('taxonomy');
		$(catItem).on('click', (e) => {
			this.postIds = [];
			if (!$(e.currentTarget).hasClass('is-active')) {
				$(catItem).removeClass('is-active');
				$(e.currentTarget).addClass('is-active');
				this.activeTab = $(e.currentTarget).data('taxonomy');

				if (this.activeTab !== 'all') {
					const activeTab = this.activeTab;
					const filteredPosts = this.origPosts.filter(function () {
						const postCat = $(this).data('taxonomy');
						return postCat
							.split(',')
							.map((c) => c.trim())
							.includes(activeTab);
					});

					if (filteredPosts.length > 0) {
						this.toggleArchivePost(filteredPosts);
						this.consolidatePostId(filteredPosts);
					} else {
						this.toggleArchivePost('<p>No results found</p>');
					}
				} else {
					this.toggleArchivePost(this.origPosts);
					this.consolidatePostId(this.origPosts);
				}
			}
		});
	};

	toggleArchivePost = (content) => {
		const $container = $('.archive__posts');
		$container.removeClass('show hide').addClass('hide');
		setTimeout(() => {
			$container.html(content);
			$container.addClass('show');
		}, 500);
	};

	consolidatePostId = (postsObj) => {
		const $posts = $(postsObj);
		this.postIds = $posts
			.map(function () {
				return $(this).data('postid');
			})
			.get()
			.filter(Boolean);

		return this.postIds;
	};

	addMobileFilterToggle = () => {
		const filterBtn = '.mobile-blog-filter';
		const filters = '.archive__box__search, .archive__categories-wrap';
		const breakpoint = 959;

		$(document).on('click', filterBtn, function (e) {
			e.preventDefault();
			$(filters).slideToggle();
		});

		$(window).on('resize', function () {
			if ($(window).width() > breakpoint) {
				$(filters).removeAttr('style');
			}
		});
	};
}
